import * as React from "react";
import * as moment from "moment-timezone";
import styled from "styled-components";
import {
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text/Text";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { IShutdown } from "src/modules/shutdowns/api/shutdown.api";
import { ActionColumnCellRenderer } from "src/core/dashboard/components/widgets/table/columns/actionsColumn";
import { formatCustomerName } from "src/core/customers/utils/format-customer-name";
import { formatDropName } from "src/core/drops/utils/format-drop-name";
import { ITerminology } from "src/core/shared/api";

export const shutdownsTableColumns = (actionButton: ActionColumnCellRenderer<IShutdown>, terminology: ITerminology, showDropDetails?: boolean) => {
  const customColumnHelper = customCreateColumnHelper<IShutdown>();
  const columnHelper = createColumnHelper<IShutdown>();

  const columns = [
    customColumnHelper.standardTextColumn(columnHelper, "id", {
      header: "Id",
      enableColumnFilter: true,
      minSize: 100
    }),
    customColumnHelper.standardTextColumn(columnHelper, "branch.customer.accountNumber", {
      header: terminology.customer.singular.text,
      enableColumnFilter: true,
      enableSorting: false,

      cell: info => {
        return (info.row.original.branch?.customer && (
          <Text>
            {formatCustomerName(info.row.original.branch.customer)}
          </Text>
        )
        );
      },
      minSize: 100
    }),
    customColumnHelper.standardTextColumn(columnHelper, "branch.branchNumber", {
      header: terminology.drop.singular.text,
      enableColumnFilter: true,
      enableSorting: false,
      cell: info => {
        return (info.row.original.branch && (
          <Text>
            {formatDropName(info.row.original.branch)}
          </Text>
        )
        );
      },
      minSize: 100
    }),
    customColumnHelper.standardTextColumn(columnHelper, "reason", {
      enableColumnFilter: true,
      minSize: 250
    }),
    customColumnHelper.standardTextColumn(columnHelper, "endDate", {
      header: "Details",
      enableColumnFilter: false,
      enableSorting: false,
      minSize: 400,
      cell: ({ row }) => {
        if (row.original.endDate !== row.original.startDate) {
          return (
            <ShutdownCell>
              <Text>
                {`Orders will not be able to be placed on or between ${moment.utc(row.original.startDate).format("DD/MM/YYYY")} and ${moment.utc(row.original.endDate).format("DD/MM/YYYY")}`}
              </Text>
            </ShutdownCell>
          );
        } else {
          return (
            <ShutdownCell>
              <Text>
                {`Orders will not be able to be placed on ${moment.utc(row.original.startDate).format("DD/MM/YYYY")}`}
              </Text>
            </ShutdownCell>
          );
        }
      }
    }),
    customColumnHelper.actionColumn(columnHelper, actionButton, { size: 200 })
  ];

  if (!showDropDetails) {
    columns.splice(1, 2);
  }

  return columns as Array<ColumnDef<IShutdown, keyof IShutdown>>;
};

const ShutdownCell = styled.div`
  padding: 20px 0;
  white-space: pre-wrap;
`;
